<div class="desktop-header">
  <div class="header-grid boxed">
    <a class="brand-lockup" routerLink="/news">
      <app-image
        alt="Wüstenrot Logo"
        loading="eager"
        [height]="50"
        [width]="144"
        src="../../../assets/images/logo.png"
        [priority]="true" />
      <p>Produktinformationssystem</p>
    </a>
    @if ((authService.isAuthenticated() | async) === authState.Authenticated) {
      <nav class="primary-nav" aria-label="Hauptnavigation">
        <a class="menu-element" routerLink="/news">
          <app-icon alt="News" src="news-black.svg" />
          <p>News</p>
        </a>
        <a class="menu-element" routerLink="/folders">
          <app-icon alt="Beratungsmappe" src="briefcase.svg" />
          <p>Beratungsmappe</p>
        </a>
        <a
          class="menu-element has-submenu"
          [class.dropdown-open]="isProductsDropdownOpen()"
          (click)="toggleProductsDropdown()"
          (mouseenter)="isProductsDropdownOpen.set(true)"
          (mouseleave)="isProductsDropdownOpen.set(false)">
          <app-icon alt="Produkte" src="category.svg" />
          <p>Produkte</p>
          <app-icon alt="Untermenü" src="chevron-bottom.svg" className="submenu-indicator"></app-icon>

          <div class="submenu" [class.show]="isProductsDropdownOpen()">
            @if (data | async; as categoriesGroups) {
              @for (item of categoriesGroups; track item.id) {
                @if (item.pages_1.length || item.pages_2.length) {
                  <a
                    [href]="'/pages/' + (item.slug ? item.slug : item.id)"
                    [ngClass]="{ active: categoryGroupId === item.id || categoryGroupId === item.slug }"
                    (click)="onDropdownItemClick('/pages/' + (item.slug ? item.slug : item.id), $event)">
                    <p>
                      <app-icon alt="Pfeil" src="chevron-right.svg" className="submenu-item-arrow" />
                      {{ item.title }}
                    </p>
                  </a>
                }
              }
            }
          </div>
        </a>
      </nav>
      <div class="utility-cluster">
        <button
          type="button"
          class="search-trigger"
          [attr.aria-label]="searchTriggerAriaLabel"
          (click)="openGlobalSearch($event.currentTarget)">
          <app-icon alt="" [ariaHidden]="true" src="search.svg" className="search-trigger-icon" />
          <span class="search-trigger-label">Suchen</span>
          <span class="search-trigger-keycap">{{ shortcutKeyLabel }}</span>
        </button>
        <a class="menu-element" (click)="openAppsStarter()">
          <app-icon alt="Apps" src="apps.svg" />
          <p>Apps</p>
        </a>
        <a
          class="menu-element has-submenu"
          [class.dropdown-open]="isUserDropdownOpen()"
          (click)="toggleUserDropdown()"
          (mouseenter)="isUserDropdownOpen.set(true)"
          (mouseleave)="isUserDropdownOpen.set(false)">
          <app-icon alt="Benutzer" src="profile.svg" />
          <p>Benutzer</p>
          <app-icon alt="Untermenü" src="chevron-bottom.svg" className="submenu-indicator" />
          <div class="submenu show" [class.show]="isUserDropdownOpen()" style="margin-left: -80px">
            <a [routerLink]="'/users/profile/'">
              <p>
                <app-icon alt="Pfeil" src="chevron-right.svg" className="submenu-item-arrow" />
                Profil
              </p></a
            >

            <a (click)="logout()">
              <p><app-icon alt="Pfeil" src="chevron-right.svg" className="submenu-item-arrow" />Abmelden</p></a
            >
          </div>
        </a>
      </div>
    }
  </div>
</div>
@if ((authService.isAuthenticated() | async) === authState.Authenticated) {
  <app-apps-starter />
}
